import draggable from "vuedraggable";
<template>
    <div>
        <el-row style="margin-top: 30px;">
            <el-col :span="6">
                <el-form-item label="姓名"
                              prop="form1.xingming">
                    <el-input placeholder="姓名"
                              v-model="form1.xingming"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="身份证号"
                              prop="form1.shenfenzheng">
                    <el-input placeholder="身份证号"
                              v-model="form1.shenfenzheng" @blur="chufaData"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="年龄"
                >
                    <el-input placeholder="年龄"
                              v-model="form1.nianling" :disabled="false"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="性别">
                    <el-select placeholder="性别"
                               v-model="form1.xingbie">
                        <el-option label="男"
                                   value="男"></el-option>
                        <el-option label="女"
                                   value="女"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="民族"
                              prop="minzu">
                    <el-select placeholder="民族" v-model="form1.minzu" style="width: 100%">
                        <el-option v-for="item in minzu" :label="item.label" :key="item.value" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="户籍所在地" class="household">
                    <el-cascader style="width: 100%;" v-model="form1.huji" :options="city" filterable>
                    </el-cascader>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="职业">
                    <el-input placeholder="职业"
                              v-model="form1.zhiye"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="婚姻状况">
                    <el-select placeholder="婚姻状况"
                               v-model="form1.hunyin">
                        <el-option label="已婚"
                                   value="已婚"></el-option>
                        <el-option label="未婚"
                                   value="未婚"></el-option>
                        <el-option label="离异"
                                   value="离异"></el-option>
                        <el-option label="丧偶"
                                   value="丧偶"></el-option>
                        <el-option label="其它"
                                   value="其它"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="联系电话" prop="form1.dianhua">
                    <el-input placeholder="联系电话"
                              v-model="form1.dianhua"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="18">
                <el-form-item label="其他联系方式（电话/微信/邮件）"
                              label-width="260px">
                    <el-input placeholder="其他联系方式"
                              v-model="form1.lianxifangshi"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="住院号">
                    <el-input placeholder="住院号"
                              v-model="form1.hin"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="门诊号">
                    <el-input placeholder="门诊号"
                              v-model="form1.opn"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="24" style="padding-bottom: 4%;">
                <el-form-item label="联系地址">
                    <el-input placeholder="联系地址"
                              v-model="form1.lianxidizhi"></el-input>
                </el-form-item>
            </el-col>
<!--            <el-card style="margin-bottom:1%" shadow="never">-->
<!--                <div style="border-top: 1px solid #eee;padding-top:20px;margin-top:0px">-->
<!--                    <el-row>-->
<!--                        <el-col :span="4" style="margin-left:inherit">-->
<!--                            <el-dialog title="预览" append-to-body-->
<!--                                       :visible.sync="dialogVisible"-->
<!--                                       height="70%">-->
<!--                                <div>-->
<!--                                    <img :src="imageUrl"-->
<!--                                         width="100%;" :style="{transform:'rotateZ('+deg+'deg)'}">-->
<!--                                </div>-->
<!--                                <span slot="footer"-->
<!--                                      class="dialog-footer">-->
<!--                                <el-button type="info" @click="rotate">旋 转</el-button>-->
<!--                                <el-button type="primary"-->
<!--                                           @click="dialogVisible = false">确 定</el-button>-->
<!--                            </span>-->
<!--                            </el-dialog>-->
<!--                            <el-form-item label=""-->
<!--                                          label-width="20px"-->
<!--                                          prop="fileList">-->
<!--                                <el-upload class="upload-demo"-->
<!--                                           ref="uploaddemo"-->
<!--                                           action="/api/case/upload/"-->
<!--                                           :headers="uploadHeader"-->
<!--                                           :onSuccess="uploadSuccess"-->
<!--                                           :on-preview="handlePreview"-->
<!--                                           :on-remove="handleRemove"-->
<!--                                           :before-remove="beforeRemove"-->
<!--                                           :file-list="form1.baogaotupian">-->
<!--                                    <el-button type="primary">▲报告图片上传</el-button>-->
<!--                                </el-upload>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
<!--                        <el-col :span="6">-->
<!--                            <el-form-item label-width="0px">-->
<!--                                <el-button type="primary" @click="wmcode('jibenxinxi_baogaotupian')">▲扫二维码上传</el-button>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
<!--                    </el-row>-->
<!--                </div>-->
<!--            </el-card>-->
        </el-row>
        <el-dialog
            title="病例信息"
            :visible.sync="dialogVisible"
            width="55%"
            :before-close="handleClose"
        >
            <el-row>
                <el-col :span="24" v-for="(item,index ) in seek" :key="index" style="padding-bottom:10px;">
                    <el-card class="box-card">
                        <el-form-item label="姓名："
                                      label-width="90px"
                        >
                            <span>{{ item.xingming }}</span>
                        </el-form-item>
                        <el-form-item label="就诊日期"
                                      label-width="90px"
                        >
                            <span>{{ item.time }}</span>
                        </el-form-item>
                        <el-form-item label="就诊医院："
                                      label-width="90px"
                        >
                            <span>{{ item.yiyuan }}</span>
                        </el-form-item>
                        <el-form-item label="诊断："
                                      label-width="90px"
                        >
                            <span>{{ item.zhenduan }}</span>
                        </el-form-item>
                    </el-card>
                    <el-form-item label=""
                                  label-width="0px"
                                  style="text-align: center;"
                                  v-if="index !=seek.length-1"
                    >
                        <span><i class="el-icon-arrow-down" style="font-size:20px"></i></span>
                    </el-form-item>

                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-radio-group style="float: left;" v-model="bingli" size="small" @change="handleChange">
                   <el-radio :label="1" border size="medium">&nbsp;复 发&nbsp;</el-radio>
                   <el-radio :label="0" border size="medium">&nbsp;初 发&nbsp;</el-radio>
                </el-radio-group>
                <el-button type="primary" @click="jzxinxi">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="扫二维码上传"
                :visible.sync="model"
                width="30%"
                :before-close="handleQrcode">
            <erweima id="jibenxinxs" ref="jibenxinxs"/>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleQrcode">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="预览" :visible.sync="dialogVisible" height="70%" append-to-body>
            <div>
                <img :src="imageUrl" width="100%;" :style="{transform:'rotateZ('+deg+'deg)'}">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="rotate">旋 转</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as table from '../../../config/cyit'
import erweima from './widgets/erweima'


export default {
    components: {
        erweima
    },
    data() {
        let token = localStorage.getItem('token')
        return {
            uploadHeader: {Authorization: `Bearer ${token}`},
            form1: this.$store.state.registration.form1,
            restaurants: [],
            bingli: 1,
            city: table.citys,
            minzu: table.minzu,
            dialogVisible: false,
            seek: [],
            pk: 0,
            fufaId: 0,
            imageUrl: null,
            deg: 0,
            model: false
        }
    },
    methods: {
        S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        },
        guid() {
            var that = this
            return (that.S4() + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + that.S4() + that.S4());
        },
        wmcode(value) {
            var that = this
            that.model = true
            if (!that.$store.state.registration.form1.uuid) {
                that.$store.state.registration.form1.uuid = that.guid()
            }
            if (that.$store.state.registration.form1.uuid) {
                var url = window.location.href.split('#')[0] + 'case/uploadsredoce/?field='
                url = url + value + '&uuid=' + that.$store.state.registration.form1.uuid
                that.$nextTick(() => {
                    that.$refs.jibenxinxs.useqrcode(url)
                })
            } else {
                that.$message({
                    message: '请先暂存数据，再刷新页面',
                    type: 'warning'
                })
            }
        },
        rotate() {
            this.deg += 90;
            if (this.deg >= 360) {
                this.deg = 0
            }
        },
        quchong(data) {
            var b = []
            var tem = data.concat(this.form1.baogaotupian);
            var len = tem.length;
            var i = 0;
            var arr = [];
            if (data.length == 0){
                return b
            }
            for (; i < len; i++) {
                var t = tem[i];
                if (arr.indexOf(t['id']) == -1) {
                    arr.push(t['id']);
                    b.push(t);
                }

            }
            return b
        },
        getimage(value) {
            this.$http.get(`/case/image/list/?filed=${value}&uid=${this.$store.state.registration.form1.uuid}`)
                .then(resp => {
                    this.form1.jibenxinxi_baogaotupian = this.quchong(resp.data.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        handleQrcode() {
            this.model = false
            this.getimage('jibenxinxi_baogaotupian')
        },
        uploadSuccess(response, file) {
            this.$store.state.registration.form1.baogaotupian.push(file.response)
        },
        handlePreview(e) {
            var name = e.url.split('.').pop()
            if (name == "pdf") {
                window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
            } else if (name == "png" || name == "jpeg" || name == "bmp" || name == "jpg") {
                window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
            } else {
                window.location = window.location.href.split('#')[0] + e.url.slice(1)
            }
        },
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        handleRemove(file, fileList) {
            this.$store.state.registration.form1.baogaotupian = fileList
            this.$store.dispatch({
                type: 'delImage',
                pk: file.id,

            }).then(resp => {
                if (resp.data.code == 1) {
                    this.$message({message: '删除成功！', type: 'success'})
                } else if (resp.data.code == -1) {
                    this.$message({message: resp.data.errors, type: 'error'})
                }
            });
        },
        jzxinxi() {
            this.dialogVisible = false
            if (!this.bingli && this.pk) {
                this.$router.push({
                    path: '/rms/registration/' + this.pk,
                })
            } else if (this.bingli && this.fufaId) {
                this.$emit('childCopy', this.fufaId)
            }
            this.getAge()
            this.bingli = 1
        },
        handleClose() {

        },
        handleChange() {
            this.$emit('childEvent', this.bingli)
            this.form1.bingli = this.bingli
        },
        chufaData() {
            if (this.form1.shenfenzheng.length != 18) {
                return
            }
            this.getAge()
            if (this.form1.shenfenzheng.substring(0,4)!="0000") {
                this.$http.get(`/case/card/?card=${this.form1.shenfenzheng}`)
                    .then(resp => {
                        if (resp.data.code == 1) {
                            var that = this
                            if (that.pk == resp.data.pk) {
                                this.getAge()
                            } else {
                                that.dialogVisible = true
                                that.seek = resp.data.data
                                that.pk = resp.data.pk
                                that.fufaId = resp.data.id
                                that.handleChange()
                            }
                            // }else{
                            // this.getAge()
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
        getAge() {
            //获取年龄
            var UUserCard = this.form1.shenfenzheng
            var myDate = new Date();
            var month = myDate.getMonth() + 1;
            var day = myDate.getDate();
            var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
            if (UUserCard.substring(10, 12) < month || UUserCard.substring(10, 12) == month && UUserCard.substring(12, 14) <= day) {
                age++;
            }
            var gender = UUserCard.slice(14, 17) % 2 ? "1" : "2";
            if (gender == '1') {
                gender = '男'
            } else {
                gender = '女'
            }
            this.form1.xingbie = gender
            this.form1.nianling = age;
        },
        querySearch(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
            };
        },
        handleSelect(item) {
            console.log(item);
        }
    },
    mounted() {
        // this.$http.get('/autocomplete/huji/')
        //   .then(resp => {
        //     that.restaurants = resp.data.data
        //   })
    }
};
</script>
<style scoped>
/deep/ .el-cascader-menu__wrap {
    height: 300px
}

/deep/ .el-dialog {
    background-color: #ebeff0;
}

.el-dialog .el-form-item {
    /*margin-bottom: 5px;*/
}

/deep/ .el-dialog__headerbtn {
    display: none;
}
</style>
